import React from 'react';
import Upload from './upload/Upload';
function Homepage(props) {
    return (
        <>
            <div className="homepage_postion">
                <h2 style={{ lineHeight: "60px" }}> Welcome to</h2>
                <h4>the Photo Booth of the NaMo App</h4>
            </div>

            <Upload />
        </>
    )
}
export default Homepage;
